<template>
	<div ref="loginModal">
		<div class="login-container">
			<div class="cube"></div>
			<form
				id="login_form"
				method="POST"
				:action="loginUrl"
				@submit="handleLogin"
				class="mini"
			>
				<div class="ln-ct-account">
					<p>{{ getConstants('PRICING_NEW_ACCOUNT') }}</p>
					<input
						type="text"
						v-model="account"
						name="login_email"
						class="lc-ct-input"
						@input="accountInit = true"
						:class="{ warning: accountInit && accountInvalid }"
					/>
				</div>
				<div class="ln-ct-password">
					<p>{{ getConstants('PRICING_NEW_PASSWORD') }}</p>
					<input
						type="password"
						name="login_password"
						v-model="password"
						class="lc-ct-input"
						@input="passwordInit = true"
						:class="{ warning: passwordInit && passwordInvalid }"
					/>
				</div>
				<div class="ln-ct-status clearfix">
					<div class="remember fl-l">
						<nut-checkbox
							@on-change="checkChange"
							name="remember_me"
							:label="getConstants('PRICING_NEW_REMEMBER_ME')"
							:isChecked="isRemember"
							size="12"
						></nut-checkbox>
					</div>
					<div class="forget fl-r">
						<a href="/forget_pwd">{{ getConstants('PRICING_NEW_FORGET') }}</a>
					</div>
				</div>
				<div class="ln-ct-confirm">
					<button type="submit" class="btn-confirm">
						{{ getConstants('LOGIN') }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import NutCheckbox from './NutCheckbox'

export default {
	data() {
		return {
			isRemember: true,
			account: '',
			password: '',
			accountInit: false,
			passwordInit: false,
			loginUrl: `/d/login?next=${encodeURIComponent(
				location.pathname + location.search,
			)}`,
		}
	},
	computed: {
		accountInvalid() {
			const reg = /^\w+((.?\w+)*|(-?\w+)*)@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).?[A-Za-z0-9]+$/
			return !this.account || !reg.test(this.account)
		},
		passwordInvalid() {
			return !this.password
		},
	},
	methods: {
		handleLogin(e) {
			this.accountInit = true
			this.passwordInit = true
			if (this.accountInvalid || this.passwordInvalid) {
				e.preventDefault()
			}
		},
		checkChange(e) {
			this.isRemember = e
		},
		hideModal(e) {
			if (!this.$refs.loginModal.contains(e.target)) {
				this.$emit('hideModal')
			}
		},
	},
	components: {
		NutCheckbox,
	},
	mounted() {
		document.body.addEventListener('click', this.hideModal)
	},
	beforeDestroy() {
		document.body.removeEventListener('click', this.hideModal)
	},
}
</script>

<style lang="scss" scoped>
.login-container {
	border: 1px solid #eee;
	border-radius: 4px;
	font-size: 14px;
	.cube {
		position: absolute;
		background: #fff;
		right: 56px;
		top: -10px;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 0 10px 10px 10px;
		border-color: transparent transparent #eeeeee transparent;
		&::before {
			position: absolute;
			content: '';
			top: 1px;
			left: -10px;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 0 10px 10px 10px;
			border-color: transparent transparent #fff transparent;
		}
	}
}
.ln-ct-account {
	p {
		line-height: 24px;
	}
}
.ln-ct-password {
	padding-top: 14px;
	p {
		line-height: 24px;
	}
}
.login-container {
	box-sizing: border-box;
	width: 320px;
	padding: 22px 40px;
	background: #fff;
	box-shadow: 0 4px 8px 0 rgba(110, 110, 110, 0.05);
	.lc-ct-input {
		width: 240px;
		height: 32px;
	}
	.lc-ct-input.warning {
		border-color: #ff5252;
	}
}
.ln-ct-confirm {
	.btn-confirm {
		width: 240px;
		height: 36px;
		background: #299bff;
		color: #fff;
	}
}
.ln-ct-status {
	line-height: 44px;
	padding-bottom: 12px;
	.forget {
		a {
			font-size: 14px;
		}
	}
}
</style>
